module.exports = "/assets/data/3208a532df0e313d36d5e97a4a3e6461-NG12.data.json";